import RegionSeriesIndicator from './RegionSeriesIndicator';

/** Goldman Sachs Recommendation History Indicator */
export default class GSRecommendationIndicator extends RegionSeriesIndicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 */
	_getDefaultParams() {
		return {
			id: 'gsrecommendation',
			name: 'Goldman Sachs Recommendation History',
			description: 'The Goldman Sachs Recommendation History chart indicator represents historical buy, sell, or hold recommendations.',
			inputs: [
				{ name: 'WSODIssue', value: 'auto' },
				{ name: 'ReportType', value: 'Research Report' }
			],
			noClip: true
		};
	}

	/**
	 * Returns a color based on the rating
	 * @returns {string} - Color from styles collection
	 * @property {string} rating - Accumulate / Hold / Reduce
	 */
	_getBackgroundColor(rating) {
		const style = this.params.style;
		switch (rating) {
			case 'Not Rated':
				return style.notrated.background.color;
			case 'CoverageDrop':
			case 'Reduce':
			case 'Sell':
				return style.negative.background.color;
			case 'Accumulate':
			case 'Buy':
				return style.positive.background.color;
			default: return style.neutral.background.color;
		}
	}

	/**
	 * @param {object} data Symbol data object
	 * @returns {undefined}
	 */
	render(data = {}) {
		this.regions = [];
		const rows = data.gsrecommendation;
		if (rows && rows.length) {
			rows.forEach((row, idx) => {
				const dateStart = row.date;
				const dateStop = idx < rows.length - 1 ? rows[idx + 1].date : new Date();
				const rating = row.gsrecommendation;
				const color = this._getBackgroundColor(rating.ProviderRating);
				const coords = this._renderRegion(dateStart, dateStop, color);
				if (coords) {
					this.regions.push({
						coords: this._renderRegion(dateStart, dateStop, color),
						date: row.date,
						providerRating: rating.ProviderRating
					});
				}
			});
		}
	}
}
